import { Component, NgModule } from '@angular/core';
import { ConfirmationService, Header, MessageService } from 'primeng/api';
import { ILogin } from '../@types/ILogin';
import { FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../core/auth/service/auth.service';
import { lastValueFrom } from 'rxjs';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
  providers: [MessageService, ConfirmationService]
})

export class LoginComponent {

  public showLoader = false;
  backendVersion: string = ""; 
  resetDialog: boolean = false;

  public form = this.fb.group({
    nome: this.fb.control('', [Validators.required]),
    senha: this.fb.control('', [Validators.required]),
  });

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private loginService: AuthService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService){
      this.loginService.getVersion().subscribe(version => {
        this.backendVersion = version;
      });
    }

  show(type: string, titulo: string, msg: string) {
    this.messageService.add({ severity: type, summary: titulo, detail: msg });
  }

  async handleSubmit(): Promise<void> {
    this.showLoader = true;
    try {
      await lastValueFrom(this.loginService.signIn(this.form.value as ILogin));
      this.router.navigate(['/manutencao-projetos']);
    } catch (error){
      this.messageService.add({
        severity: 'error',
        summary: 'Login',
        detail: 'Erro ao tentar fazer login!',
      });
    }

    // (error: HttpErrorResponse | any) {
    //   this.show('error', 'Erro ao logar', error.message);

    this.showLoader = false;
  }

  resetarSenha() {
    this.router.navigate(['/reset']);
  }
}
